document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const selectors = [
    '.ad-hero__image img',
    '.ad-category__image img',
    '.ad-wholesale__image img',
    '.ad-story__image img',
    '.ad-studio-still img',
    '.ad-manifesto > img'
  ];

  const images = Array.from(document.querySelectorAll(selectors.join(',')));
  if (!images.length) return;

  images.forEach((img) => img.classList.add('ad-scroll-drift-media'));

  let ticking = false;
  const update = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    images.forEach((img) => {
      const rect = img.getBoundingClientRect();
      if (rect.bottom < -120 || rect.top > vh + 120) return;

      const center = rect.top + rect.height / 2;
      const normalized = Math.max(-1, Math.min(1, (center - vh / 2) / (vh / 2 + rect.height / 2)));
      const y = normalized * -8; // 16px total travel from entering to leaving viewport
      const scale = 1.012 - Math.abs(normalized) * 0.004;
      img.style.setProperty('--ad-scroll-y', `${y.toFixed(2)}px`);
      img.style.setProperty('--ad-scroll-scale', scale.toFixed(4));
    });
    ticking = false;
  };

  const requestUpdate = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  update();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
});
